import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

import { PaginatedResultModel, PaginationSearchModel } from '@data-layer/models/common';
import { ManagementEventModel, ManagementStatementModel, ManagementStatementShortModel } from '@data-layer/models/management';

@Injectable({
  providedIn: 'root',
})
export class StatementsManagementRepository {
  constructor(private apiService: ApiService) {}

  public search(
    params: PaginationSearchModel,
    isShowLoader: boolean = true,
  ): Observable<PaginatedResultModel<ManagementStatementShortModel>> {
    return this.apiService.get<PaginatedResultModel<ManagementStatementShortModel>>(
      `${environment.url.prefixCustoms}v2/management/statements`,
      null,
      {
        isShowLoader,
      },
    );
  }

  public get(id: number, isShowLoader: boolean = true): Observable<ManagementStatementModel> {
    return this.apiService.get<ManagementStatementModel>(`${environment.url.prefixCustoms}v2/management/statements/${id}`, null, {
      isShowLoader,
    });
  }

  public getEvents(
    id: number,
    params: PaginationSearchModel,
    isShowLoader: boolean = false,
  ): Observable<PaginatedResultModel<ManagementEventModel>> {
    return this.apiService.get<PaginatedResultModel<ManagementEventModel>>(
      `${environment.url.prefixCustoms}v2/management/statements/${id}/events`,
      { params },
      { isShowLoader },
    );
  }

  public resetProviderEvent(statementId: number, eventId: number): Observable<void> {
    return this.apiService.put<void>(`${environment.url.prefixCustoms}v2/management/statements/${statementId}/last-event-id`, eventId);
  }

  public syncStatements(statementId: number): Observable<ManagementStatementModel> {
    return this.apiService.post<ManagementStatementModel>(
      `${environment.url.prefixCustoms}v2/management/statements/${statementId}/resynchronize`,
    );
  }
}
